setPristineObjects();

function preLoadNecessaryData () {
    var token = window.location.hash.split("?t=")[1];
    if (token) {
       localStorage.setItem("t", token);
       localStorage.removeItem("env");
    } else {
       token = localStorage.getItem("t") || "";
    }

    return $.ajax({
        url: "./general/settings",
        method: "GET",
        dateType: "JSON",
        data: {preLoad: true, detailed: true, t: token},
        headers: {"X-User" : "*"}
    })
}

function wire (data) {
    if(data.status !== 'ok' && window.location.hash !== '#/old-login') { //TODO remove window.location.hash checking
        window.location.href = data.redirectTo;
    } else{
        var relatedPermissions = {
            'viewBanners': ['editDetailed'],
            'manageBanners': ['editItem', 'createItem'],
            'manageNews': ['editItem', 'createItem'],
            'managePromotions': ['editItem', 'createItem'],
            'managePages': ['editItem', 'createItem'],
            'manageCustomCss': ['viewMobileCustomCss', 'manageMobileCustomCss'],
            'viewAndroidAppSettings': ['viewIosAppSettings', 'manageIosAppSettings'],
            'viewPages': ['editDetailed'],
            'viewSkinGames': ['replace', ['allowSkinsListUse', 'viewAllGames'], 'viewAllSkinGames'],
            'manageSkinGames': ['replace', ['allowSkinsListUse', 'viewAllGames'], 'manageAllSkinGames'],
            'viewSkinPayments': ['replace', ['allowSkinsListUse'], 'viewPayments'],
            'manageSkinPayments': ['replace', ['allowSkinsListUse'], 'managePayments'],
            'viewSkinCategoriesProviders': ['replace', ['allowSkinsListUse', 'viewAllGames'], 'viewCategoriesProviders'],
            'manageSkinCategoriesProviders': ['replace', ['allowSkinsListUse', 'viewAllGames'], 'manageCategoriesProviders'],
            'viewGameReleases': ['replace', ['allowSkinsListUse', 'viewAllGameReleases'], 'viewGameReleases'],
            'manageGameReleases': ['replace', ['allowSkinsListUse', 'viewAllGameReleases'], 'manageGameReleases'],
            'viewCasinoSettings': ['replace', ['allowSkinsListUse', 'viewAllCasinoSettings'], 'viewCasinoSettings'],
            'manageCasinoSettings': ['replace', ['allowSkinsListUse', 'viewAllCasinoSettings'], 'manageCasinoSettings'],
        };
        document.addRelatedStates = function addRelatedStates(states, skin){
            if (!skin || skin.id !== '165840') {
                var index1 = states.indexOf('viewCasinoJackpotBanners');
                if (index1 > 0) {
                    states.splice(index1, 1);
                }
                var index2 = states.indexOf('manageCasinoJackpotBanners');
                if (index2 > 0) {
                    states.splice(index2, 1);
                }
            }
            var length = states.length;
            for(var i = 0; i < length; ++i) {
                var relatedStates = relatedPermissions[states[i]];
                if (relatedStates) {
                    var relatedStatesLength = relatedStates.length;
                    if (relatedStatesLength > 0 && relatedStates[0] === 'replace') {
                        var neededPermissionsLength = relatedStates[1].length;
                        var isAllowed = true;
                        for(var k = 0; k < neededPermissionsLength; ++k){
                            if (states.indexOf(relatedStates[1][k]) === -1) {
                                isAllowed = false;
                                break;
                            }
                        }
                        if (isAllowed) {
                            states[i] = relatedStates[2];
                        }
                    } else {
                        for (var j = 0; j < relatedStatesLength; ++j) {
                            var state = relatedStates[j];
                            if (states.indexOf(state) === -1) {
                                states.push(state);
                            }
                        }
                    }


                }
            }
        }
        if (data.userInfo && data.userInfo.permissions) {
            document.addRelatedStates(data.userInfo.permissions, data.skin);
        }
        angular.module("app").value("preLoadedData", {data: data});
        document.getUserData = function () {
            return angular.copy(data.userInfo);
        };
        angular.element(document.body).ready(function () {
            angular.bootstrap($(document.body), ["app"]);
        });
    }

}

function setPristineObjects() {
    angular.module("app").value("preLoadedData", {data: null});
}


function forceWire () {
   // window.location.href = 'https://backoffice.betconstruct.com/login.html';
    angular.element(document.body).ready(function () {
        angular.bootstrap($(document.body), ["app"]);
    });
}

//app wire point
preLoadNecessaryData().done(wire).fail(forceWire);
